import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Colaboradores35Service {

  idEmpresa: string;
  idUsuario: string;
  infoUsers:any;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
    this.infoUsers = infoUsu;
  }

  getinfo(){
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    return infoUsu;

  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    if (this.infoUsers.level!=6) {
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);

    }else{
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + localStorage.getItem('companyID'));

    }
  }

  getStatusColaboradores(anio: number){
    let datos: any = {fechaCertificar: anio,	colaboradores: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusColaboradores(anio: number){
    let datos: any = {fechaCertificar: anio,	colaboradores: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  guardaColaboradores(anio: number, nombres: any, bd: any){
    let datos: any = {fechaCertificar: anio, columnas: nombres, bdcolaboradores:bd};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaColaboradores + this.idEmpresa, datos);
  }

  getColaboradoresFast(anio: number, producto: string){
    let datos: any = {fechaCertificar: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFast + this.idEmpresa, datos);
  }

  getColaboradoresFull(anio: number, producto: string){
    let datos: any = {fechaCertificar: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFull + this.idEmpresa, datos);
  }

  borrarColaboradores(anio: number, producto: string){
    let datos: any = {fechaCertificar: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.borrarColaboradores + this.idEmpresa, datos);
  }

  getColaboradoresFastTmp(anio: number, producto: string){ // OBTENER COLACORADORES
    let datos: any = {fechaNorma35: anio, productoId:producto};
        if (this.infoUsers.level!=6) {
          return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetColaboradores35 + this.idEmpresa, datos);
        }else{
          return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetColaboradores35 + localStorage.getItem('companyID'), datos);
        }
  }




}
